import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceMerchantEntityState} from "../reducers/ecommerce-merchant.reducer";
import {IEcommerceMerchantHashEntityState} from "../reducers/ecommerce-merchant-hash.reducer";
import {IEcommerceWorkspaceMerchantsState} from "../reducers/ecommerce-workspace-merchants.reducer";
import {
    IEcommerceMerchantPayoutsAmountEntityState
} from "../reducers/ecommerce-payouts-amount.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceMerchantState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceMerchant.entities[websiteId]);

export const getEcommerceMerchantHashState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceMerchantHash.entities[websiteId]);


export const getEcommerceMerchantPayoutsAmountState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceMerchantPayoutsAmount.entities[websiteId]);

export const getMerchantId = (websiteId: number) => createSelector(getEcommerceMerchantState(websiteId),
  (state: IEcommerceMerchantEntityState) => {
    return state.merchantId;
  }
);
export const getMerchantHash = (websiteId: number) => createSelector(getEcommerceMerchantState(websiteId),
  (state: IEcommerceMerchantEntityState) => {
    return state?.merchantHash;
  }
);
export const getExistingMerchantHash = (websiteId: number) => createSelector(getEcommerceMerchantHashState(websiteId),
  (state: IEcommerceMerchantHashEntityState) => {
    return state?.existingMerchantHash;
  }
);
export const getExistingMerchantPayoutsAmount = (websiteId: number) => createSelector(getEcommerceMerchantPayoutsAmountState(websiteId),
  (state: IEcommerceMerchantPayoutsAmountEntityState) => {
    return state?.payoutsAmount;
  }
);
export const getMerchantPublicKey = (websiteId: number) => createSelector(getEcommerceMerchantState(websiteId),
  (state: IEcommerceMerchantEntityState) => {
    return state?.publicKey;
  }
);

export const getActiveMerchantHash = (websiteId: number, merchantId: string, env: string) => createSelector(getEcommerceMerchantState(websiteId),
  (state: IEcommerceMerchantEntityState) => {
    return state?.merchantHash;
  }
);

export const getDomainsMerchants = (websiteId: number) => createSelector(getEcommerceMerchantState(websiteId),
  (state: IEcommerceMerchantEntityState) => {
    return state.merchant;
  }
);

export const getMerchantLoading = (websiteId: number) => createSelector(getEcommerceMerchantState(websiteId),
  (state: IEcommerceMerchantEntityState) => state && state.loading
);

export const getMerchantLoaded = (websiteId: number) => createSelector(getEcommerceMerchantState(websiteId),
  (state: IEcommerceMerchantEntityState) => state && state.loaded
);



export const getEcommerceWorkspaceMerchantsState = () =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceWorkspaceMerchants);

export const getWorkspaceMerchants = () => createSelector(getEcommerceWorkspaceMerchantsState(),
  (state: IEcommerceWorkspaceMerchantsState) => {
    return state.merchants;
  }
);
